export const SET_APP_STATE_MESSAGE = 'SET_APP_STATE_MESSAGE';
export const SET_APP_DARK_MODE = 'SET_APP_DARK_MODE';
export const SET_APP_SELECTED_VEHICLE = 'SET_APP_SELECTED_VEHICLE';
export const SET_APP_LOADING = 'SET_APP_LOADING';

export const SET_ACCOUNT = 'SET_ACCOUNT';
export const CREATE_ACCOUNT = 'CREATE_ACCOUNT';
export const SET_NEW_VEHICLE = 'SET_NEW_VEHICLE';
export const SAVE_NEW_VEHICLE = 'SAVE_NEW_VEHICLE';
export const RESET_NEW_VEHICLE = 'RESET_NEW_VEHICLE';

export const SET_MESSAGE_ERROR = 'SET_MESSAGE_ERROR';
export const SET_MESSAGE_LOADING = 'SET_MESSAGE_LOADING';
export const SET_MESSAGE_RESET = 'SET_MESSAGE_RESET';
export const SET_MESSAGE_OPEN = 'SET_MESSAGE_OPEN';


export const ADD_VEHICLE = 'ADD_VEHICLE';
export const SAVE_VEHICLE = 'SAVE_VEHICLE';
export const SAVE_VEHICLES = 'SAVE_VEHICLES';
export const LOAD_VEHICLE = 'LOAD_VEHICLE';

export const SET_BLACKBOOK = 'SET_BLACKBOOK';
export const RESET_BLACKBOOK = 'RESET_BLACKBOOK';


export const AUTH_INIT = 'AUTH_INIT';
export const AUTH_START = 'AUTH_START';
export const AUTH_STOP = 'AUTH_STOP';
export const AUTH_SET_RESET_PASSWORD = 'AUTH_SET_RESET_PASSWORD';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_SET_TOKEN = 'AUTH_SET_TOKEN';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_LOGOUT_SUCCESS = 'AUTH_LOGOUT_SUCCESS';
export const AUTH_SET_USER_VERIFICATION = 'AUTH_SET_USER_VERIFICATION';
export const AUTH_SET_LOGIN_FORM_EMAIL = 'AUTH_SET_LOGIN_FORM_EMAIL';

export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';
// dashboard
// export const SET_ACTIVE_PANEL_TAB = 'SET_ACTIVE_PANEL_TAB';
// export const RESET_ACTIVE_PANEL_TAB = 'RESET_ACTIVE_PANEL_TAB';
export const UPDATE_PANEL_TAB = 'UPDATE_PANEL_TAB';
export const EXPAND_ALL_TABS = 'EXPAND_ALL_TABS';
export const EXPAND_TAB_ONLY = 'EXPAND_TAB_ONLY';

export const SET_QUALIFY_QUESTIONS = 'SET_QUALIFY_QUESTIONS'
export const RESET_QUALIFY_QUESTIONS = 'RESET_QUALIFY_QUESTIONS'

export const SET_QUALIFY_VEHICLE_QUESTIONS = 'SET_QUALIFY_VEHICLE_QUESTIONS'
export const RESET_QUALIFY_VEHICLE_QUESTIONS = 'RESET_QUALIFY_VEHICLE_QUESTIONS'

export const SET_APP_DATA = 'SET_APP_DATA';